import * as Yup from 'yup'

/** Formik schema for Customer Refund Shipment ship form */
const customerRefundShipmentShipSchema = Yup.object().shape({
  tracking_no: Yup.string()
    .required('Required'),
  cost: Yup.string()
    .required('Required')
})

export default customerRefundShipmentShipSchema
